import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HelperService } from "../helper.service";
import { HttpClient, HttpErrorResponse} from "@angular/common/http";
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CompaniesService {

  environmentUrl = "Debug api";

  constructor(private http: HttpClient, private helperService: HelperService) {
    this.environmentUrl = environment.apiUrl;
  }

  public getCompanies(): any {
    return this.http.get<any>(`${this.environmentUrl}/api/company`);
  }
  public getCompaniesV2(search: string = ''): any {
    return this.http.get<any>(`${this.environmentUrl}/api/companies/v2/all`, {
      params: {
        search
      }
    });
  }
  public getCompanyUsers(companyId: number): Observable<any> {
    return this.http.get<any>(`${this.environmentUrl}/api/companies/v2/users/${companyId}`);
  }
  public getAllUsers(): Observable<any> {
    return this.http.get<any>(`${this.environmentUrl}/api/companies/v2/users`);
  }
  
  editCompanyV2(id: number, company: any): Observable<any> {
    return this.http.patch<any>(
      `${this.environmentUrl}/api/companies/v2/update/${id}`,  
      company,
      this.helperService.headers()  
    ).pipe(
      catchError(error => {
        throw error;
      })
    );
  }
  createCompanyV2(company: any): Observable<any> {
    return this.http.post<any>(
      `${this.environmentUrl}/api/companies/v2/add`,  
      company,
      this.helperService.headers()  
    ).pipe(
      catchError(error => {
        throw error;
      })
    );
  }
  
  getCompanyByIdV2(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/companies/v2/${id}`, 
      this.helperService.headers()
    );
  }
  public createCompanyUser(companyId: number, userData: any): Observable<any> {
    return this.http.post<any>(
      `${this.environmentUrl}/api/companies/v2/users/${companyId}/add`,  
      userData,  
      this.helperService.headers() 
    ).pipe(
      catchError(error => {
        console.error('Error creating company user:', error);
        throw error;  
      })
    );
  }
  public updateCompanyUser(userId: number, userData: any): Observable<any> {
    return this.http.put<any>(
      `${this.environmentUrl}/api/companies/v2/users/${userId}/edit`,
      userData,
      this.helperService.headers() 
    ).pipe(
      catchError(error => {
        console.error('Error updating user by ID:', error);
        throw error;
      })
    );
  }
  public getUserById(userId: number): Observable<any> {
    return this.http.get<any>(
      `${this.environmentUrl}/api/companies/v2/users/findById/${userId}`,
      this.helperService.headers() 
    ).pipe(
      catchError(error => {
        console.error('Error fetching user by ID:', error);
        throw error;
      })
    );
  }
    
 
  




  public createCompany(company): any {
    return this.http.post<any>(`${this.environmentUrl}/api/company`,company);
  }

  public updateCompany(company): any {
    return this.http.post<any>(`${this.environmentUrl}/api/company`,company);
  }

  public deleteCompany(id): any {
    return this.http.delete<any>(`${this.environmentUrl}/api/company/${id}`);
  }

}
